import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance from '../../Apis/Axios';
import { TRAFFIC_FINE_SERVICE } from '../EndPoints';


export const GetAllFineTypes = createAsyncThunk("trafficFinesSection/GetAllFineTypes",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(TRAFFIC_FINE_SERVICE.getAllFineTypes).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetGeofenceConfigSetting = createAsyncThunk("trafficFinesSection/GetGeofenceConfigSetting",async (params, { dispatch, getState }) => {

    const response = await apiInstance.get(TRAFFIC_FINE_SERVICE.getGeofenceConfigSetting).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const GetAllLocationsByUserAndByDates = createAsyncThunk('trafficFinesSection/getAllLocationsByUserAndByDates',
    async ({ body }) => {
        const response = await apiInstance
            .post(TRAFFIC_FINE_SERVICE.getAllLocationsByUserAndByDates,body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    });

export const GetAllFineByDates = createAsyncThunk('trafficFinesSection/getAllLocationsByUserAndByDates',
    async ({ params,body }) => {
        const response = await apiInstance
            .post(TRAFFIC_FINE_SERVICE.getAllFineByDates(params.from, params.to),body)
            .then((response) => {
                return response;
            })
            .catch((error) => {
                return error.response;
            });
        const { data, status } = response;
        return { data, status };
    });

export const CreateFine = createAsyncThunk("trafficFinesSection/CreateFine",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(TRAFFIC_FINE_SERVICE.createFine, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const CreateEvidencesFine = createAsyncThunk("trafficFinesSection/CreateEvidencesFine",
    async (params, { dispatch, getState }) => {
    const response = await apiInstance.post(TRAFFIC_FINE_SERVICE.createEvidencesFine, params, {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    }).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

